import React from 'react'
import moment from 'moment'
import DayColumn from './DayColumn'
import { getDayIntervals } from './utils'
import { IScaleInterval, ICellConfig, ECellColor } from './calendarTypes'

interface CalendarBodyProps {
  preview?: boolean
  firstDay: moment.Moment
  minDay?: moment.Moment
  maxDay?: moment.Moment
  scaleIntervals: IScaleInterval[]
  onSelectionStart(colPos: number, rowPos: number, day: moment.Moment): void
  onClick(colPos: number, rowPos: number): void
  onCellMouseEnter(colPos: number, rowPos: number): void
  outsideRangeColor?: ECellColor
  cellConfigs: ICellConfig[]
  cellHeight: number
  cellWidth: number
  numberOfDays: number
  fontSize: string
}

const CalendarBody: React.FC<CalendarBodyProps> = ({
  preview,
  firstDay,
  minDay,
  maxDay,
  scaleIntervals,
  onSelectionStart,
  onClick,
  onCellMouseEnter,
  outsideRangeColor,
  cellHeight,
  cellWidth,
  cellConfigs,
  numberOfDays,
  fontSize,
}) => {
  return (
    <>
      {Array.from(Array(numberOfDays).keys()).map((_key, index) => {
        const day = moment(firstDay).add(index, 'd')
        const intervals = getDayIntervals(day, scaleIntervals)
        return (
          <DayColumn
            key={index}
            preview={preview}
            colPos={index}
            cellHeight={cellHeight}
            cellWidth={cellWidth}
            dayIntervals={intervals}
            cellConfigs={cellConfigs}
            minDay={minDay}
            maxDay={maxDay}
            outsideRangeColor={outsideRangeColor}
            onSelectionStart={onSelectionStart}
            onClick={onClick}
            onCellMouseEnter={onCellMouseEnter}
            fontSize={fontSize}
          />
        )
      })}
    </>
  )
}

export default CalendarBody
